import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttpError } from '../../errors';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AssessmentCriteriaService {

    private assessmentCriteriaError = new Subject<boolean>();
    public assessmentCriteriaError$ = this.assessmentCriteriaError.asObservable();

    constructor(private http: HttpClient) { }

    public postAssessmentCriteria(examinationId, werkprocessId, data): any {
        return this.http.post<string>(`/kerntaken/${examinationId}/werkproces/${werkprocessId}/beoordelingsvorm`, data)
            .pipe(catchError(error => {
                this.assessmentCriteriaError.next(false);
                throw new HttpError(`Probleem bij het versturen van de cijfer informatie`);
            }));
    }
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/assessment-criteria.service.ts